import { SalesOrderPaymentStatus } from '@/lib/enums/SalesOrderPaymentStatus'
import { cn } from '@/lib/utils'
import { Badge, type BadgeProps } from '../ui/badge'
import { DynamicIcon } from '../ui/DynamicIcon'
import type { SalesOrderPaymentStatus as SalesOrderPaymentStatusValue } from '@/lib/services/sales-orders/sales-orders.types'
import { CircleX } from 'lucide-react'

type OrderPaymentStatusBadgeProps = {
  status: SalesOrderPaymentStatusValue | null
  cancelledAt?: string | null
  size?: BadgeProps['size']
  onClick?: BadgeProps['onClick']
  className?: string
}

function OrderPaymentStatusBadge({
  status,
  cancelledAt = null,
  size = 'md',
  onClick,
  className = '',
}: OrderPaymentStatusBadgeProps) {
  if (cancelledAt) {
    return (
      <Badge variant="destructive" size={size} className={cn(className)} onClick={onClick}>
        <CircleX className={cn(size === 'sm' ? 'size-3' : 'size-4')} />
        Cancelled
      </Badge>
    )
  }

  const paymentStatus = Object.values(SalesOrderPaymentStatus).find(
    (statusItem) => statusItem.Value === status
  )

  if (!paymentStatus) {
    return null
  }

  return (
    <Badge variant={paymentStatus.Variant} size={size} className={cn(className)} onClick={onClick}>
      {paymentStatus.Icon && (
        <DynamicIcon
          iconName={paymentStatus.Icon}
          className={cn(size === 'sm' ? 'size-3' : 'size-4')}
        />
      )}

      {paymentStatus.Name}
    </Badge>
  )
}

export default OrderPaymentStatusBadge
